import { t } from "@wr/i18n";
import { COMMIT, ENV, IS_PRODUCTION_ENV } from "../env";

export interface BuildFooterProps {
  /** The api's own SHA, from `/api/v1/version`. `null` while it is in flight. */
  apiCommit: string | null;
}

/**
 * The splash build footer — **LOCKED** (design spec §5). Closes S1 QA findings
 * N1 and N7 together.
 *
 * Two labelled values on line 1 and the environment on line 2:
 *
 *   web 1f4433d · api 69486cc
 *   STAGING
 *
 * **N7 — the SHAs are labelled** because web and api legitimately differ. A
 * migration-only commit redeploys some services and not others (that is what
 * Railway's watch paths are for), so one unlabelled number is a number that
 * sends someone looking at the wrong deploy.
 *
 * **N1 — the environment is the truth.** It comes from `VITE_ENV`, fed from
 * `RAILWAY_ENVIRONMENT_NAME` at image build time, and the Dockerfile fails the
 * build when it is empty. Vite's `MODE` is never rendered here: it says
 * "production" for any optimised build, which is exactly how the staging
 * splash came to claim it was production.
 *
 * In production the environment line is omitted entirely (§5) — there is no
 * ambiguity to resolve for a player on www.
 */
export function BuildFooter({ apiCommit }: BuildFooterProps) {
  return (
    <footer className="wr-build-footer" data-testid="build-footer">
      <span className="wr-mono-xs">
        {t("splash.buildWeb")} {COMMIT} · {t("splash.buildApi")} {apiCommit ?? "—"}
      </span>
      {IS_PRODUCTION_ENV ? null : (
        <span className="wr-mono-xs" data-testid="build-env">
          {ENV}
        </span>
      )}
    </footer>
  );
}
